import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { Page } from '../../model/page.model';
import { UserDetails } from '../../model/user-details.model';
import { AddressService } from '../../service/address.service';
import { StateService } from '../../service/state.service';
import { UserService } from '../../service/user.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-account',
  imports: [RouterOutlet, RouterLink, RouterLinkActive,CommonModule],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {

  unsubscribe$ = new Subject();
  user: UserDetails = new UserDetails();
  page: Page = { pageNo: 1, pageSize: 20 };

  constructor(public route: Router,
    private userService: UserService,
    private stateService: StateService,
    private addressService: AddressService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.fetchUserData();
    this.fetchUserAddress();

    this.stateService.loadUser$.pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.fetchUserData();
      })

    this.stateService.loadUserAddress$.pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.fetchUserAddress();
      })

  }

  private fetchUserData() {
    this.stateService.shimmerLoaderUpdate(true);
    this.userService.getUserDetails().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: res => {
          this.user = res.data[0];
          this.stateService.shimmerLoaderUpdate(false);
          this.stateService.sendUserDetails(this.user);
        },
        error: (err) => {
          this.toastr.error("Something Went Wrong")
          this.stateService.shimmerLoaderUpdate(false);
        }
      });
  }

  private fetchUserAddress() {
    this.addressService.getUserAddressList(this.page).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: res => {
          res.data.list.sort((a, b) => Number(b.defaultAddress) - Number(a.defaultAddress));
          this.stateService.sendUserAddressDetails(res.data.list);
        },
        error: (err) => {
          this.toastr.error("Something Went Wrong")
        }
      });

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}
